import Box from "@mui/material/Box";
import Grid from "@mui/material/Grid"
import List from "@mui/material/List";
import ListItem from "@mui/material/ListItem";
import ListItemIcon from "@mui/material/ListItemIcon";
import ListItemText from "@mui/material/ListItemText";
import Radio from "@mui/material/Radio";
import Typography from "@mui/material/Typography";
import React, { useEffect, useState } from "react";
import UrlService from "../../../services/url.service";
import EnvService from "../../../services/env.service";
import useStyles, {
  useListItemStyles,
  useListStyles
} from "./select-login-style";

const LOGIN_PF = "PF";
const LOGIN_PJ = "PJ";

function SelectLogin() {
  const [selectedLogin, setSelectedLogin] = useState({});

  const localEnv = EnvService.getEnv();

  useEffect(() => {
    setSelectedLogin(LOGIN_PF);
  }, []);

  const handleSelectLogin = (loginType) => (e) => {
    e.stopPropagation();
    setSelectedLogin(loginType);
  };

  const handleNextButtonClick = async () => {
    try {
      var paramLoginType = UrlService.getQueryString("login");
      if(!paramLoginType) throw new Error("Parametro 'login' não encontrado");
      
      var env = `REACT_APP_${paramLoginType}_${selectedLogin}`;
      var redirect = localEnv[env];
      if(!redirect) throw new Error(`ENV ${env} não foi definida`);
      
      window.location = redirect + decodeURIComponent(UrlService.getQueryString("callback"));
    } catch (e) {
      console.error(e);
    }
  };
  
  const styles = useStyles();
  const listItemStyles = useListItemStyles();
  const listStyles = useListStyles();

  return (
    <Box>
      <Grid container spacing={2} style={{margin:0, width: '100%'}}>
        <Grid xs={5} >
          <Box>
            <img src="/images/shutterstock_1515200282.png" style={{width: '100%', maxHeight: '100%'}} alt=""/>
          </Box>
        </Grid>
        <Grid xs={7} className={styles.root}>
          <Box style={{width: '371px'}}>
            <img src="/images/bb-logo-blue.svg" className={styles.logo} alt="Logo Banco do Brasil" />
            <Typography variant="h2" style={{textAlign: 'justify'}}>
              Para começar, selecione o seu <b>perfil</b>
            </Typography>
            <List classes={listStyles}>
              <ListItem
                key="item-pf"
                classes={listItemStyles}
                onClick={handleSelectLogin(LOGIN_PF)}
                className={selectedLogin === LOGIN_PF ? styles.itemSelected : ""}
              >
                <ListItemIcon>
                  <Radio
                    color="primary"
                    checked={selectedLogin === LOGIN_PF}
                    onClick={handleSelectLogin(LOGIN_PF)}
                  />
                </ListItemIcon>
                <ListItemText
                  primary={`Pessoa Física`}
                />
              </ListItem>
              <ListItem
                key="item-pj"
                classes={listItemStyles}
                onClick={handleSelectLogin(LOGIN_PJ)}
                className={selectedLogin === LOGIN_PJ ? styles.itemSelected : ""}
              >
                <ListItemIcon>
                  <Radio
                    color="primary"
                    checked={selectedLogin === LOGIN_PJ}
                    onClick={handleSelectLogin(LOGIN_PJ)}
                  />
                </ListItemIcon>
                <ListItemText
                  primary={`Pessoa Jurídica`}
                />
              </ListItem>
            </List>
            <Box style={{marginTop:'100px'}}>
              <dls-button size="regular" fullwidth color="primary" onClick={handleNextButtonClick} style={{fontFamily: 'BancoDoBrasilTitulos-Bold'}}>
                Avançar
              </dls-button>
            </Box>
          </Box>
        </Grid>
      </Grid>
    </Box>
  );
}

export default SelectLogin;
